import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon, InfoIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { whatYouReceiveItems } from '../../data/whatYouReceive';
export function WhatYouReceive() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-276" data-mp="182cyphyi5s6i">
      <div className="mx-auto max-w-2xl px-4 text-center sm:px-6" data-id="element-277" data-mp="1d168azao4z1e">
        <SectionTag icon="📦" tone="primary" data-id="element-278" data-mp="1d3inx5syexba">
          Antes de comprar
        </SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold leading-tight text-primary sm:text-4xl" data-id="element-279" data-mp="z8gcy4992hrm">
          ¿Qué recibes con Pilates 360?
        </h2>
        <p className="mt-4 text-base leading-relaxed text-ink sm:text-lg" data-id="element-280" data-mp="pd6d9n6bqmh0">
          Un sistema de consulta y planificación para profesionales de Pilates, compuesto por materiales
          digitales que puedes utilizar como referencia al preparar tus clases.
        </p>
      </div>

      <div className="mx-auto mt-8 max-w-xl px-4 sm:px-6" data-id="element-281" data-mp="kda4zbqlg8vn">
        <ul className="space-y-3" data-id="element-282" data-mp="keuyqz533nsg">
          {whatYouReceiveItems.map((item, i) => <m.li key={item} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: i * 0.06
        }} className="flex items-center gap-3 rounded-xl border border-primary/10 bg-paper px-5 py-3.5" data-id="element-283" data-mp="gw8vcnu6ofei" data-mpi={i}>
              <CheckIcon size={18} className="flex-shrink-0 text-success" data-id="element-284" data-mp="3ua3szi2drg4e" />
              <span className="text-sm font-medium text-ink" data-id="element-285" data-mp="3pahfd7in3xv2">{item}</span>
            </m.li>)}
        </ul>

        <div className="mt-6 flex items-start gap-3 rounded-2xl border border-gold/30 bg-gold/5 px-5 py-4" data-id="element-286" data-mp="7uj3jgwe3eg7">
          <InfoIcon size={18} className="mt-0.5 flex-shrink-0 text-[#9c7a4f]" data-id="element-287" data-mp="31zffq02t0x5" />
          <p className="text-sm leading-relaxed text-ink/80" data-id="element-288" data-mp="3bhriu95hjajp">
            Producto digital descargable. No incluye clases grabadas en vídeo ni formación presencial.
          </p>
        </div>
      </div>
    </section>;
}